import { raiseUnknownSubmissionType } from "../../../../types/supabase";
import { RequireSubmissionProvided, requireSubmission } from "../../../wrappers/requireSubmission";
import { SubmitPersonalResponsibility } from "./submitPersonalResponsibility";
import { SubmitToCHM } from "./submitToCHM";
import { SubmitToHRA } from "./submitToHRA";
import { SubmitToSedera } from "./submitToSedera";
import { SubmitToSMI } from "./submitToSMI";

interface SubmitShowProps extends RequireSubmissionProvided {
}

export function SubmitShow({submission}: SubmitShowProps) {
  const type = submission.submission_type
  switch(type) {
    case 'CHM':
    case 'CHM-addon':
      return <SubmitToCHM submission={submission} />
    case 'Sedera':
    case 'Sedera-addon':
      return <SubmitToSedera submission={submission} />
    case 'SMI':
    case 'SMI-addon':
      return <SubmitToSMI submission={submission} />
    case 'HRA':
      return <SubmitToHRA submission={submission} />
    case 'CHM-personal-responsibility':
      return <SubmitPersonalResponsibility submission={submission} />
    default:
      raiseUnknownSubmissionType(type)
  }
}

export default requireSubmission(SubmitShow)
